import CoursePlan from './CoursePlan';

export default CoursePlan;
